import { VWO } from './vwo.js';

(() => {
    function handleIntersection(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                console.log('Best seller scrolled into view (scrolledPastHero)');
                VWO.event('scrolledPastHero');
                observer.unobserve(entry.target);
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersection, {
        root: null,
        threshold: 0.5
    });

    const bestSellersSection = document.getElementById('best_sellers');

    if (bestSellersSection) {
        observer.observe(bestSellersSection);
    }
})();
